import { render, staticRenderFns } from "./change-barcode.vue?vue&type=template&id=43253384&"
import script from "./change-barcode.vue?vue&type=script&lang=js&"
export * from "./change-barcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports